import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { NgStyle } from '@angular/common';
import { DefaultLayoutAlignDirective, DefaultLayoutDirective } from 'ng-flex-layout';

@Component({
  standalone: true,
  selector: 'app-new-spinner',
  templateUrl: './new-spinner.component.html',
  styleUrls: ['./new-spinner.component.scss'],
  imports: [
    NgStyle,
    DefaultLayoutAlignDirective,
    DefaultLayoutDirective,
  ],
})
export class NewSpinnerComponent implements OnInit, OnChanges{
  @Input() size = 80;
  defaultSize = 80;
  public scaleFactor = 1;

  ngOnInit(): void {
    this.calculateScale();
  }

  ngOnChanges(): void {
    this.calculateScale();
  }

  calculateScale(): void {
    this.scaleFactor = this.size / this.defaultSize;
  }
}
